/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide-graphics/dialog-after': {
    width: 16,
    height: 16,
    viewBox: '0 0 40.5 80',
    data: '<g data-name="Layer 2"><path pid="0" d="M0 0c22.37 0 40.5 17.91 40.5 40S22.37 80 0 80z" _fill="#fff" data-name="Layer 1"/></g>'
  }
})
